import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { RevealLine, Reveal } from "../lib/motion";
import { IMG } from "../data";

const ParallaxImage = ({ src, alt }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);
  return (
    <div ref={ref} className="relative overflow-hidden h-full">
      <motion.img style={{ y, scale: 1.2 }} src={src} alt={alt} className="w-full h-full object-cover" />
    </div>
  );
};

export const Lifestyle = () => (
  <section id="lifestyle" data-testid="lifestyle-section" className="py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-6 sm:px-12">
      <div className="max-w-2xl mb-16">
        <div className="overline mb-6">Motor Valley · Wine & Lifestyle</div>
        <h2 className="font-serif text-4xl sm:text-5xl leading-tight text-[var(--ink)]">
          <RevealLine>Dove passione</RevealLine>
          <RevealLine delay={0.08} className="italic text-[var(--petrol)]">e impresa si incontrano.</RevealLine>
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        <Reveal className="group">
          <div className="aspect-[4/5] overflow-hidden mb-6"><ParallaxImage src={IMG.car} alt="Motor Valley" /></div>
          <div className="text-xs uppercase tracking-[0.15em] text-[var(--accent)] mb-2">Motor Valley</div>
          <h3 className="font-serif text-3xl text-[var(--ink)] mb-2">L'eccellenza italiana del motorsport</h3>
          <p className="text-[var(--ink-soft)] leading-relaxed">Investimenti e progetti legati al territorio della Motor Valley, tra heritage, innovazione e imprenditoria.</p>
        </Reveal>
        <Reveal delay={0.12} className="group md:mt-24">
          <div className="aspect-[4/5] overflow-hidden mb-6"><ParallaxImage src={IMG.wine} alt="Wine & Lifestyle" /></div>
          <div className="text-xs uppercase tracking-[0.15em] text-[var(--accent)] mb-2">Wine & Lifestyle</div>
          <h3 className="font-serif text-3xl text-[var(--ink)] mb-2">Il gusto del tempo ben speso</h3>
          <p className="text-[var(--ink-soft)] leading-relaxed">Un progetto lifestyle che celebra il vino, la cultura e l'arte di vivere con eleganza e misura.</p>
        </Reveal>
      </div>
    </div>
  </section>
);
